import { render, staticRenderFns } from "./addStaticSegment.vue?vue&type=template&id=358db8fa&lang=pug"
import script from "./addStaticSegment.vue?vue&type=script&lang=js"
export * from "./addStaticSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports